module.exports = __webpack_public_path__ + "static/media/sound.86756a17.svg";